//@flow
import React from "react";
import { connect } from "react-redux";
import SelectInput from "../../../../comum/SelectInput";
import { type State, getMesesEAnosCompostos } from "../../../../../state";
import { type MesEAnoComposto } from "../../../../../model";

type Props = {
  listaMesesEAnosCompostos: Array<MesEAnoComposto>,
  mesEAnoCompostoSelecionado: string,
  onChange: any => any,
  disabled: boolean,
};

function SelecaoMesAnoComposto({
  listaMesesEAnosCompostos,
  mesEAnoCompostoSelecionado,
  onChange,
  disabled,
}: Props) {
  return (
    <div className="ConfiguracaoMedida">
      <SelectInput
        onChange={onChange}
        value={mesEAnoCompostoSelecionado}
        options={listaMesesEAnosCompostos}
        size={5}
        multiple={false}
        campoId="nome"
        campoDescricao="nomeTraduzido"
        disabled={disabled}
      />
    </div>
  );
}

export default connect(
  (state: State) => ({
    listaMesesEAnosCompostos: getMesesEAnosCompostos(state),
  }),
  {}
)(SelecaoMesAnoComposto);
